import React, { Component } from 'react'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'
import phoneFormatter from 'phone-formatter'
import moment from 'moment'

import { displayDollars } from '../../../helpers/displayFormatHelper'
import { Employment, Income, Task } from '../types'
import TaskImage from '../taskImage'

export interface Props {
  task: Task
}

const Item = ({ title, data }) => (
  <div className="task-bodies__col2--mg-right-4">
    <div className="task-bodies__title">
      <h1>{title}</h1>
    </div>
    <div className="task-bodies__col3">
      <div className="task-bodies__info-header">
        {Object.keys(data).map((k, i) => (
          <div key={i} className="task-bodies__info-header__row">
            {k}
          </div>
        ))}
      </div>
      <div className="task-bodies__info-block">
        {Object.values(data).map((v, i) => (
          <div key={i} className="task-bodies__info-block__row">
            {v}
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default class EmploymentAndIncome extends Component<Props> {
  state = {
    rowLayout: false,
  }

  toggleRowLayout = () => {
    this.setState({ rowLayout: !this.state.rowLayout })
  }

  getDate = (date: string | null) => {
    const m1 = moment(`${date} 12:00:00`, 'YYYY-MM-DD HH:mm:ss')
    if (date === null) {
      return 'Present'
    } else {
      return `${m1.format('MMMM')} ${m1.format('YYYY')}`
    }
  }

  getYears = (years: number) => {
    if (years === 0 || years === null) {
      return null
    } else if (years === 1) {
      return ` (${years} year)`
    } else {
      return ` (${years} years)`
    }
  }

  calculateMonthlyIncome = (annualIncome: number) => {
    return annualIncome / 12
  }

  renderCreditApplication = () => {
    const {
      task: {
        entity: { applicant, coApplicant },
        subject,
        user,
      },
    } = this.props
    const creditAppData = subject.id !== user.id ? coApplicant : applicant

    const years = moment().diff(
      moment(creditAppData.employmentStartDate),
      'years'
    )
    const data = {
      'Job title': 'N/a',
      'Annual income': creditAppData.statedGrossIncome
        ? `${displayDollars(creditAppData.statedGrossIncome)}`
        : 'Not available',
      'Years employed': `${this.getDate(
        creditAppData.employmentStartDate
      )} - ${this.getDate(null)} ${this.getYears(years)}`,
      'Phone #': 'N/a',
    }

    return <Item title="Credit Application" data={data} />
  }

  renderEmployment = (employment: Employment, index: number) => {
    const image = employment.proofOfIncome
      ? employment.proofOfIncome
      : undefined

    const contentType = image ? image.contentType || 'UNKNOWN' : undefined
    const data = {
      'Job title': employment.occupation
        ? employment.occupation
        : 'Not available',
      'Annual income': employment.annualGrossIncome
        ? `${displayDollars(employment.annualGrossIncome)}`
        : 'Not available',
      'Years employed': `${this.getDate(employment.startDate)} - ${this.getDate(
        employment.endDate
      )}${this.getYears(employment.years)}`,
      'Phone #': employment.employerPhoneNumber
        ? `${phoneFormatter.format(
            employment.employerPhoneNumber,
            '(NNN) NNN-NNNN'
          )}`
        : 'Not available',
    }

    return (
      <div className="task-bodies__item" key={index}>
        <div className="task-bodies__col2">
          <Item
            title={startCase(capitalize(employment.employerName || ''))}
            data={data}
          />
          {index === 0 && this.renderCreditApplication()}
        </div>

        {image && (
          <div className="task-bodies__employment-wrapper" key={index}>
            <div className="task-bodies__title">
              <div key={index}>
                {contentType && contentType.match(/pdf/) ? (
                  <a href={image.url} target="_blank">
                    View PDF
                  </a>
                ) : (
                  <TaskImage
                    imgUrl={image.url}
                    toggleLayout={this.toggleRowLayout}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderIncome = (income: Income, index) => {
    const image = income.proofOfIncome ? income.proofOfIncome : undefined
    const contentType = image ? image.contentType || 'UNKNOWN' : undefined
    const data = {
      Amount: income.annualIncome
        ? `$${this.calculateMonthlyIncome(
            Number(income.annualIncome)
          ).toLocaleString()}`
        : 'Not available',
      Frequency: 'Monthly',
      'Start Date': income.startDate ? income.startDate : '',
    }

    return (
      <div className="task-bodies__employment-wrapper" key={income.id}>
        <Item title={startCase(capitalize(income.source || ''))} data={data} />
        {image && (
          <div className="task-bodies__employment-wrapper" key={index}>
            <div className="task-bodies__title">
              <div key={index}>
                {contentType && contentType.match(/pdf/) ? (
                  <a href={image.url} target="_blank">
                    View PDF
                  </a>
                ) : (
                  <TaskImage
                    imgUrl={image.url}
                    toggleLayout={this.toggleRowLayout}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      task: { verifiables: sourcesOfIncome },
    } = this.props
    const employments = sourcesOfIncome.filter(
      (s): s is Employment => (s as Employment).employerName !== undefined
    )
    const incomes = sourcesOfIncome.filter(
      (s): s is Income => (s as Income).source !== undefined
    )

    const additionalIncome = incomes.length > 0

    return (
      <div className="task-bodies__container">
        <div className="task-bodies__header">EMPLOYMENT</div>
        <div className="task-bodies__employment-list">
          {employments.map(this.renderEmployment)}
        </div>
        <div>
          {additionalIncome ? (
            <div className="task-bodies__header">ADDITIONAL INCOME</div>
          ) : null}
          {incomes.map(this.renderIncome)}
        </div>
      </div>
    )
  }
}
